import { useMemo } from 'react';
import moment from 'moment';
import { getDate, getTime } from '../pages/TopShopperPage/utils/Timer';

const getEventsLeaderboardContent = (
  saleType: string,
  data: [],
  selectedIndex: number
): Record<string, unknown> => {
  if (!data || data.length === 0)
    return {
      currentDate: '',
      timeRange: [],
      offerCardData: {},
      leaderboardData: []
    };

  const selectedIndexData = data[selectedIndex];
  const {
    slot: { date: currentTopShopperDate = '', timeInterval: currentTimeInterval = '' } = {},
    offer: { bannerImageURL = '', label = '', description = '' } = {},
    userList = []
  } = selectedIndexData || {};
  const timeRange = data.map(ele => {
    const { slot: { timeInterval = '' } = {} } = ele;
    if (timeInterval) {
      return getTime(timeInterval, '_');
    }
    return '';
  });

  return {
    selectedIndex,
    currentDate: getDate(currentTopShopperDate),
    timeRange,
    offerCardData: {
      image: bannerImageURL,
      alt: description,
      label: description,
      price: label,
      date: `${getDate(currentTopShopperDate)} : ${getTime(currentTimeInterval, '_')}`
    },
    leaderboardData: userList ? [...userList] : [],
    postDataType: selectedIndex > 0 ? 'POST_SALE' : ''
  };
};

export { getEventsLeaderboardContent };
